import { render, staticRenderFns } from "./note_actions.vue?vue&type=template&id=3960cc10&"
import script from "./note_actions.vue?vue&type=script&lang=js&"
export * from "./note_actions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "note_actions.vue"
export default component.exports